//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import shuffle from 'lodash/shuffle'
import {CollapseTransition} from "@ivanv/vue-collapse-transition";
import Swiper from "swiper";

export default {
  components: {
    CollapseTransition,
  },
  data() {
    return {
      activeProject: null,
      projects: [
        {id: 0, date: "September 17-18"},
        {id: 1, date: "September 17-18"},
        {id: 2, date: "September 17-18"},
        {id: 3, date: "September 17-18"}
      ],
      activeReference: null,
      references: [
        {
          id: 0,
          cards: {
            type: "simpleCards",
            items: [
              {
                type: "card",
                background: "#042531",
                fontColor: "#E4E9EF",
              },
              {
                type: "card",
                background: "#3A9BC3",
                fontColor: "#E4E9EF",
              },
              {
                type: "card",
                background: "#5F5A8F",
                fontColor: "#E4E9EF",
              }
            ]
          }
        },
        {
          id: 1,
          cards: {
            type: "simpleCards",
            items: [
              {
                type: "card",
                background: "#3A9BC3",
                fontColor: "#E4E9EF",
              },
              {
                type: "card",
                background: "#E4E9EE",
                fontColor: "#1F1F1F",
              },
              {
                type: "card",
                background: "#724285",
                fontColor: "#E4E9EF",
              }
            ]
          }
        },
        {
          id: 2,
          attrId: 'referenceProject2',
          cards: {
            type: "simpleCards",
            items: [
              {
                type: "card",
                background: "#19383A",
                fontColor: "#E4E9EF",
              },
              {
                type: "card",
                background: "#19383A",
                fontColor: "#FFFFFF",
              },
              {
                type: "card",
                background: "#1B4988",
                fontColor: "#E4E9EF",
              }
            ]
          }
        },
        {
          id: 3,
          cards: {
            type: "simpleCards",
            items: [
              {
                type: "card",
                background: "#3A7F77",
                fontColor: "#E4E9EF",
              },
              {
                type: "card",
                background: "#181730",
                fontColor: "#FFFFFF",
              },
              {
                type: "card",
                background: "#3B7541",
                fontColor: "#E4E9EF",
                nolink: true
              }
            ]
          }
        },
        {
          id: 4,
          cards: {
            type: "gridCol",
            items: [
              {
                type: "gridColComponentsContainer",
                components: [
                  {
                    type: "gridColText",
                  },
                ]
              },
              {
                type: "gridColComponentsContainer",
                components: [
                  {
                    type: "gridColText",
                  },
                ]
              },
              {
                type: "gridColComponentsContainer",
                components: [
                  {
                    type: "gridColBigImg",
                  },
                ]
              },
            ]
          }
        },
        {
          id: 5,
          cards: {
            type: "gridCol",
            items: [
              {
                type: "gridColComponentsContainer",
                components: [
                  {
                    type: "gridColText",
                  },
                  {
                    type: "gridColShadedText",
                  }
                ]
              },
              {
                type: "gridColComponentsContainer",
                components: [
                  {
                    type: "gridColText",
                  },
                ]
              },
              {
                type: "gridColComponentsContainer",
                components: [
                  {
                    type: "gridColShadedText",
                  },
                ]
              },
            ]
          }
        },
        {
          id: 6,
          cards: {
            type: "gridCol",
            items: [
              {
                type: "gridColComponentsContainer",
                components: [
                  {
                    type: "gridColText",
                  },
                  {
                    type: "gridColText",
                  },
                  {
                    type: "gridColBigImg",
                  },
                ]
              },
              {
                type: "gridColComponentsContainer",
                components: [
                  {
                    type: "gridColCard",
                    img: "../img/projects/companies/vc.jpg"
                  },
                  {
                    type: "gridColCard",
                    img: "../img/projects/companies/cnews.jpg"
                  },
                  {
                    type: "gridColCard",
                    img: "../img/projects/companies/rbk.jpg"
                  },
                  {
                    type: "gridColCard",
                    img: "../img/projects/companies/telekomr.jpg"
                  },
                ]
              },
              {
                type: "gridColComponentsContainer",
                components: [
                  {
                    type: "gridColCard",
                    img: "../img/projects/companies/comnews.jpg"
                  },
                  {
                    type: "gridColCard",
                    img: "../img/projects/companies/fastmode.jpg"
                  },
                  {
                    type: "gridColCard",
                    img: "../img/projects/companies/comnews.jpg"
                  },
                  {
                    type: "gridColCard",
                    img: "../img/projects/companies/samena.jpg"
                  },
                ]
              },
            ]
          }
        },
      ],
      scrollTimeout: null,
      swipers: [],
    }
  },
  created() {
    this.projects.forEach((el, key) => {
      this.$set(el, 'sort', key);
      this.$set(el, 'isActive', false);
    });
    this.references.forEach((el, key) => {
      this.$set(el, 'sort', key);
      this.$set(el, 'isActive', false);
    });
  },
  computed: {
    expandFinanceBlock () {
      return this.$store.state.expandFinanceBlock;
    }
  },
  watch: {
    expandFinanceBlock (newVal, oldVal) {
      const neededReference = this.references.find((referenceItem) => {
        return referenceItem.id === newVal;
      });
      if (neededReference) {
        if (!neededReference.isActive) {
          this.activateReference(neededReference);
        }
        this.$store.dispatch('expandFinanceBlockAction', null);
      }
    }
  },
  methods: {
    activateProject(project) {
      if (this.activeProject && project && this.activeProject.id === project.id) {
        project.isActive = false;
        this.activeProject = null;
        return;
      }
      if (this.activeProject !== null) {
        this.activeProject.isActive = false;
      }
      if (project) {
        project.isActive = true;
        this.projects[0].sort = project.sort;
        let temp = this.projects[0];
        this.$set(this.projects, 0, project);
        this.$set(this.projects, project.sort, temp);
        project.sort = 0;
        this.activeProject = project;
      }
    },
    activateReference(reference) {
      clearTimeout(this.scrollTimeout);
      const closestSticky = this.$refs['projectsApp'].closest('.content-sticky');
      if (this.activeReference) {
        const lastActive = this.activeReference;
        if (this.swipers.hasOwnProperty(this.activeReference.id)) {
          this.swipers[this.activeReference.id].destroy();
        }
        this.activeReference.isActive = false;
        this.activeReference = null;

        if (reference && lastActive.id === reference.id) {
          if (closestSticky) {
            closestSticky.classList.remove('content-sticky_disabled');
          }
          return;
        }
      }
      if (reference !== null) {
        if (closestSticky) {
          closestSticky.classList.add('content-sticky_disabled');
        }
        this.activeReference = reference;
        reference.isActive = true;
        this.$nextTick(() => {
          this.scrollTimeout = setTimeout(() => {
            this.$store.dispatch('scrollToElement', {
              element: this.$refs[`projectReference${reference.id}Id`][0],
              duration: 600
            });

            if (this.$mq === 'mobile') {
              this.$nextTick(() => {
                if (reference.cards.type === 'simpleCards') {
                  const container = this.$refs[`projectsSwiperContainer${reference.id}`][0];
                  this.swipers[reference.id] = new Swiper(container, {
                    slidesPerView: 'auto',
                    allowTouchMove: true,
                  });
                }
              });
            }

          }, 600);
        });
      }
    },
    goToSlide(slideNumber, sliderId) {
      const swiperInstance = this.swipers[sliderId];
      swiperInstance.slideTo(slideNumber);
    },
    firePreviousSlide(sliderId) {
      const swiperInstance = this.swipers[sliderId];
      if (swiperInstance) {
        const currentIndex = swiperInstance.realIndex;
        let nextIndex = currentIndex - 1;
        if (nextIndex < 0) {
          return;
          // nextIndex = this.swiper.slides.length - 1;
        }
        this.goToSlide(nextIndex, sliderId);
      }
    },
    fireNextSlide(sliderId) {
      const swiperInstance = this.swipers[sliderId];
      if (swiperInstance) {
        const currentIndex = swiperInstance.realIndex;
        let nextIndex = currentIndex + 1;
        if (nextIndex >= swiperInstance.slides.length) {
          return;
          // nextIndex = 0;
        }
        this.goToSlide(nextIndex, sliderId);
      }

    },
  },
}
